import { Phone, MessageCircle, Instagram, MapPin, Clock, Navigation } from "lucide-react";
import { FadeUp } from "@/components/motion/Reveal";
import { BUSINESS, MAPS_DIRECTIONS, MAPS_EMBED } from "@/data/site";
import { waGeneral } from "@/lib/wa";

export default function Contact() {
  const rows = [
    { icon: Phone, label: "Telefon", value: BUSINESS.phoneDisplay, href: `tel:${BUSINESS.phoneRaw}`, testid: "contact-phone" },
    { icon: MessageCircle, label: "WhatsApp", value: BUSINESS.phoneDisplay, href: waGeneral(), testid: "contact-whatsapp", target: "_blank" },
    { icon: Instagram, label: "Instagram", value: BUSINESS.instagramHandle, href: BUSINESS.instagram, testid: "contact-instagram", target: "_blank" },
    { icon: MapPin, label: "Adres", value: BUSINESS.address, href: MAPS_DIRECTIONS, testid: "contact-address", target: "_blank" },
  ];

  return (
    <section id="iletisim" className="bg-ivory py-20 sm:py-28" data-testid="contact-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="mb-12">
          <FadeUp>
            <p className="eyebrow text-gold mb-4">İletişim</p>
          </FadeUp>
          <FadeUp delay={0.05}>
            <h2 className="font-serif text-espresso text-4xl sm:text-5xl lg:text-6xl">
              Bize <span className="italic">Ulaşın</span>
            </h2>
          </FadeUp>
        </div>

        <div className="grid lg:grid-cols-12 gap-8 items-start">
          {/* details */}
          <div className="lg:col-span-5">
            <FadeUp>
              <div className="divide-y divide-espresso/10 border-y border-espresso/10">
                {rows.map((r) => (
                  <a
                    key={r.label}
                    href={r.href}
                    target={r.target}
                    rel={r.target ? "noopener noreferrer" : undefined}
                    data-testid={r.testid}
                    className="group flex items-start gap-4 py-5 transition-colors hover:text-gold"
                  >
                    <r.icon size={20} strokeWidth={1.5} className="mt-1 text-gold shrink-0" />
                    <div>
                      <p className="eyebrow text-espresso/50 text-[10px] mb-1">{r.label}</p>
                      <p className="text-espresso group-hover:text-gold text-lg leading-snug">{r.value}</p>
                    </div>
                  </a>
                ))}
              </div>

              {/* hours */}
              <div className="mt-8">
                <p className="flex items-center gap-2 eyebrow text-espresso/50 text-[10px] mb-4">
                  <Clock size={14} className="text-gold" /> Çalışma Saatleri
                </p>
                <ul className="space-y-2">
                  {BUSINESS.hours.map((h) => (
                    <li key={h.day} className="flex justify-between text-sm border-b border-dashed border-espresso/10 pb-2">
                      <span className="text-espresso/70">{h.day}</span>
                      <span className={`font-medium ${h.time === "Kapalı" ? "text-espresso/40" : "text-espresso"}`}>{h.time}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <a
                href={MAPS_DIRECTIONS}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-directions-button"
                className="mt-8 inline-flex items-center gap-2 rounded-full bg-espresso px-8 py-4 text-ivory text-sm font-medium transition-transform duration-300 hover:scale-[1.03] active:scale-95"
              >
                <Navigation size={16} /> Yol Tarifi Al
              </a>
            </FadeUp>
          </div>

          {/* map */}
          <FadeUp delay={0.1} className="lg:col-span-7">
            <div className="rounded-2xl overflow-hidden border border-espresso/10 h-[380px] sm:h-[480px] bg-beige/40">
              <iframe
                title="Hülya Suna Beauty Konum"
                src={MAPS_EMBED}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="contact-map"
              />
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
